import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../theme';

interface FooterProps {
  onTermsClick?: () => void;
  onPrivacyClick?: () => void;
}

const FooterContainer = styled.footer`
  background: ${theme.colors.surface};
  border-top: 1px solid ${theme.colors.border.light};
  padding: ${theme.spacing.xxxl} 0 ${theme.spacing.xl};
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.xl};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 ${theme.spacing.lg};
  }
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.xl};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
    text-align: center;
    gap: ${theme.spacing.lg};
  }
`;

const Logo = styled.div`
  font-size: ${theme.typography.fontSize.xl};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.primary};
  font-family: ${theme.typography.fontFamily.secondary};
  
  &::before {
    content: '🍳 ';
    margin-right: ${theme.spacing.xs};
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.xl};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    gap: ${theme.spacing.lg};
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const NavLink = styled.a`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  text-decoration: none;
  transition: color 0.2s ease;
  font-family: ${theme.typography.fontFamily.primary};

  &:hover {
    color: ${theme.colors.primary};
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid ${theme.colors.border.light};
  padding-top: ${theme.spacing.lg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
    text-align: center;
    gap: ${theme.spacing.md};
  }
`;

const Copyright = styled.p`
  color: ${theme.colors.text.light};
  font-size: ${theme.typography.fontSize.sm};
  margin: 0;
  font-family: ${theme.typography.fontFamily.primary};
`;

const LegalLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.lg};

  button, a {
    background: none;
    border: none;
    color: ${theme.colors.text.light};
    font-size: ${theme.typography.fontSize.sm};
    text-decoration: none;
    transition: color 0.2s ease;
    font-family: ${theme.typography.fontFamily.primary};
    cursor: pointer;
    padding: 0;

    &:hover {
      color: ${theme.colors.primary};
    }

    &:focus {
      outline: 2px solid ${theme.colors.primary};
      outline-offset: 2px;
      border-radius: 2px;
    }
  }
`;

const Footer: React.FC<FooterProps> = ({ onTermsClick, onPrivacyClick }) => {
  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <Logo>厨记</Logo>
          <NavLinks>
            <NavLink href="mailto:blackenvelope@163.com">联系我们</NavLink>
            <NavLink href="#">关于我们</NavLink>
            <NavLink href="#">帮助中心</NavLink>
          </NavLinks>
        </FooterContent>

        <FooterBottom>
          <Copyright>
            © 2025 厨记 保留所有权利 | 浙ICP备2025204372号-1
          </Copyright>
          <LegalLinks>
            <Link to="/privacy">隐私政策</Link>
            <Link to="/terms">服务条款</Link>
            {/* Keep modal buttons for backward compatibility */}
            <button type="button" onClick={onPrivacyClick} style={{ display: 'none' }}>隐私政策(模态框)</button>
            <button type="button" onClick={onTermsClick} style={{ display: 'none' }}>服务条款(模态框)</button>
          </LegalLinks>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default Footer;